const initialState = {
    data: [], 
    
  
  };
  
  const AActivitiesReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default AActivitiesReducers;
  
  